import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, renderIcon } from '@ecdlink/ui';
import { createContext, useContext, useEffect, useState, useRef, } from 'react';
const Snackbar = ({ message, duration, type, onClose, }) => {
    const [visible, setVisible] = useState(true);
    const isMounted = useRef(true);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    useEffect(() => {
        if (!visible && isMounted.current) {
            onClose();
        }
    }, [visible, onClose]);
    useEffect(() => {
        const timer = setTimeout(() => {
            if (isMounted.current)
                setVisible(false);
        }, duration);
        return () => clearTimeout(timer);
    }, [duration]);
    const handleClose = () => {
        if (isMounted.current)
            setVisible(false);
    };
    return (_jsx("div", Object.assign({ className: `fixed bottom-4 left-1/2 z-50 w-11/12 -translate-x-1/2 transform rounded-md transition-opacity ${visible ? 'opacity-100' : 'pointer-events-none opacity-0'}` }, { children: _jsx(Alert, { type: type, title: message, variant: "outlined", button: _jsx("button", Object.assign({ onClick: handleClose, className: "absolute top-0 bottom-0 right-4 my-0" }, { children: renderIcon('XIcon', `${type === 'success' ? 'text-white' : 'text-gray-900'} h-6 w-6`) })) }) })));
};
const SnackbarContext = createContext(undefined);
export const SnackbarProvider = ({ children }) => {
    const [message, setMessage] = useState('');
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(5000);
    const [snackbarType, setSnackbarType] = useState('success');
    const isMounted = useRef(true);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    const showMessage = ({ message, duration, type }) => {
        if (!isMounted.current)
            return;
        setMessage(message);
        setIsSnackbarOpen(true);
        if (type) {
            setSnackbarType(type);
        }
        if (duration) {
            setSnackbarDuration(duration);
        }
        else {
            setSnackbarDuration(5000);
        }
    };
    const closeSnackbar = () => {
        if (isMounted.current)
            setIsSnackbarOpen(false);
    };
    return (_jsxs(SnackbarContext.Provider, Object.assign({ value: { showMessage } }, { children: [children, isSnackbarOpen && (_jsx(Snackbar, { message: message, duration: snackbarDuration, onClose: closeSnackbar, type: snackbarType }))] })));
};
export const useSnackbar = () => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return context;
};
//# sourceMappingURL=index.js.map